




















import { Component, Vue, Prop } from "vue-property-decorator";

import { Plants, Plant } from "@/types";

import PlantBackground from "@/components/PlantBackground.vue";
import PlantTypeNavButton from "@/components/PlantTypeNavButton.vue";
import PlantSearch from "@/components/PlantSearch.vue";

@Component({
  components: { PlantBackground, PlantTypeNavButton, PlantSearch },
})
export default class PlantsView extends Vue {
  get plants() {
    return this.$store.state.plants as Plants;
  }

  get types() {
    return this.$store.state.plantTypes;
  }
}
